import * as z from 'zod'

import { LIABILITY_CONSTANTS } from '@flows/configs/shared/constants'
import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import * as validators from '@flows/configs/shared/validators'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { FAILURE_STEP_NAME } from '@flows/insurance/constants'
import { BaseSchema_LiabilityV1GetsafeDe } from '@flows/insurance/schemas'

const claimsOptionsFromSchema = schemaUtils.getEnumValuesFromPipelineSchema(
  BaseSchema_LiabilityV1GetsafeDe.shape.number_of_claims_in_last_5y.unwrap()
)

const liability_damages = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('number_of_claims_in_last_5y')]:
        validators.createPreprocessedEnumNumberSchema(z.enum([...claimsOptionsFromSchema, '3'])),
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_liabilityNxt:steps.damages.title',
        },
      },
      {
        type: 'choice',
        name: params.helperFunctions.getParamPath('number_of_claims_in_last_5y'),
        shouldTrackValues: true,
        options: LIABILITY_CONSTANTS.claimsOptions,
      },
      {
        type: 'infoBox',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_liabilityNxt:steps.liability.damages.infoText',
        },
      },
    ],
    subFlow: params.subFlow,
    nextStepConfig: {
      valuePath: params.helperFunctions.getParamPath('number_of_claims_in_last_5y'),
      valueToStepName: {
        0: 'liability_cancelled',
        1: 'liability_cancelled',
        2: 'liability_cancelled',
        3: FAILURE_STEP_NAME,
      },
    },
  }) as const satisfies AnyStepConfiguration

export default liability_damages
